import { get } from 'svelte/store';
import { userSettings } from '../store/ui';
import { playAudio } from './audio';

// HOT TO USE: use:clickSound={{sound: 'audio_basic_click', volume: 1}} on DOM element
function clickSound(node, { sound, volume = 1 }) {
    const handleClick = () => {
        const $userSettings = get(userSettings);
        if ($userSettings.soundEnabled) {
            playAudio(window.__assets_cache[sound], { volume });
        }
    };

    node.addEventListener('click', handleClick, { passive: true });

    return {
        destroy() {
            node.removeEventListener('click', handleClick);
        }
    };
}

export default clickSound;
